import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PersonaContext } from "../context/PersonaContext";
import Header from "../components/Header";
import StatusBar from "../components/StatusBar";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import { getLocations, retryApiCall } from "../services/api";

const LocationPage = () => {
  const { selectedLocation, setSelectedLocation } = useContext(PersonaContext);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [validationError, setValidationError] = useState("");
  const navigate = useNavigate();

  const fetchLocations = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await retryApiCall(getLocations);
      setLocations(data);
    } catch (error) {
      setError("Failed to load locations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleNextClick = () => {
    if (!selectedLocation) {
      setValidationError("Please select a location");
      return;
    }
    navigate("/sectors");
  };

  const handleSelect = (location) => {
    setSelectedLocation(location);
    setValidationError("");
  };

  return (
    <div className="location-page">
      <Header />
      <StatusBar currentStep={0} />
      <h2>Select Location</h2>
      <p>Select a location that is relevant to your persona creation.</p>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {error && (
            <div className="error-container">
              <ErrorMessage message={error} />
              <button onClick={fetchLocations} className="retry-button">
                Try Again
              </button>
            </div>
          )}
          {validationError && <ErrorMessage message={validationError} />}

          <ul className="location-list">
            {locations.map((location) => (
              <li key={location}>
                <input
                  type="radio"
                  id={`location-${location}`}
                  name="location"
                  value={location.id}
                  checked={selectedLocation === location}
                  onChange={() => handleSelect(location)}
                />
                <label htmlFor={`location-${location}`}>
                  {location === "Both" ? "Both England and Scotland" : location}
                </label>
              </li>
            ))}
          </ul>
          <div className="navigation-buttons">
            <button onClick={() => navigate("/")} className="back-button">
              Back
            </button>
            <button onClick={handleNextClick} className="next-button">
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default LocationPage;
